import n from "classnames";
import { cardContainer as c, isEditMode as h, title as p, cardChildItem as g } from "./CardGridContainer.css.js";
import { jsxs as x, jsx as d } from "react/jsx-runtime";
function N({
  element: t,
  className: r,
  isEditMode: s,
  children: o
}) {
  const {
    customAttributes: m,
    title: e,
    mobile_hide: l,
    desktop_hide: a,
    gridProps: i
  } = t;
  return /* @__PURE__ */ x("div", {
    ...m,
    className: n(c, {
      "mobile:hidden": l,
      "desktop:hidden": a,
      [h]: s
    }, r),
    style: {
      "--grid-x": i.x + 1,
      "--grid-y": i.y + 1,
      "--grid-w": i.w,
      "--grid-h": i.h
    },
    children: [e && /* @__PURE__ */ d("h1", {
      className: p,
      children: e
    }), /* @__PURE__ */ d("div", {
      className: g,
      children: o
    })]
  });
}
export {
  N as CardGridContainerElement
};
